import { defineMessages } from 'react-intl';

export const productCardMessages = defineMessages({
  addToWishList: {
    defaultMessage: 'Add {name} to wishlist',
    id: 'productCard.addToWishlist',
  },
  removeFromWishList: {
    defaultMessage: 'Remove {name} from wishlist',
    id: 'productCard.removeFromWishlist',
  },
  productNameAndSku: {
    defaultMessage: '{name}, reference {sku}.',
    id: 'productCard.productNameAndSku',
  },
  linkToPdp: {
    defaultMessage: 'Link to product details.',
    id: 'productCard.linkToPdp',
  },
  linkToPlp: {
    defaultMessage: 'Link to {collection} collection.',
    id: 'productCard.linkToPlp',
  },
});
